import React, { useCallback } from "react";
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";
import { AppDialog } from "../../components/AppDialog/AppDialog";
import { NomenclatureListPageDialog } from "./NomenclatureListPageDialog";
import { ICategorizableItem } from "../models/categorizedNomenclatureModels";
import { showCustomConfirmDialog } from "../../components/dialogs/AppConfirmDialog";

interface IItemFormDialogProps<
  TFormModel extends FieldValues & ICategorizableItem,
  TItemModel extends ICategorizableItem
> {
  visible: boolean;
  title: string;
  form: UseFormReturn<TFormModel>;
  formFields: React.ReactNode;
  items: TItemModel[];
  editingItemId: number | null;
  isSubmitting: boolean;
  onHide: () => void;
  onSubmit: (data: TFormModel) => void;
}

export const ItemFormDialog = <
  TFormModel extends FieldValues & ICategorizableItem,
  TItemModel extends ICategorizableItem
>({
  visible,
  title,
  form,
  formFields,
  items,
  editingItemId,
  isSubmitting,
  onHide,
  onSubmit,
}: IItemFormDialogProps<TFormModel, TItemModel>) => {
  const handleHide = useCallback(() => {
    if (form.formState.isDirty) {
      showCustomConfirmDialog(
        "Имате несъхранени промени. Сигурни ли сте, че искате да затворите?",
        onHide,
        undefined,
        "warning",
        "Затвори",
        "Остани",
      );
      return;
    }
    onHide();
  }, [form.formState.isDirty, onHide]);

  return (
    <AppDialog visible={visible} header={title} onHide={handleHide}>
      <FormProvider {...form}>
        <NomenclatureListPageDialog
          formFields={formFields}
          onSubmit={onSubmit}
          items={items as any[]}
          itemIdToUpdate={editingItemId}
          isLoading={isSubmitting}
        />
      </FormProvider>
    </AppDialog>
  );
};
